import { useState, useEffect } from 'react';
import { nuvemshopService } from '../services/nuvemshop';

// Hook para buscar produtos
export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await nuvemshopService.getProducts();
        setProducts(data);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Erro ao buscar produtos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return { products, loading, error, refetch: () => {} };
};

// Hook para buscar categorias
export const useCategories = () => {
  const [categories, setCategories] = useState([
    { id: 'all', name: 'Todos' }
  ]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await nuvemshopService.getCategories();
        setCategories([{ id: 'all', name: 'Todos' }, ...data]);
      } catch (err) {
        console.error('Erro ao buscar categorias:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading };
};

export default useProducts;
